export default "__VITE_ASSET__$BJO4em1__"